// copied from bundles/teach-course/components/ToggleSwitch to avoid app coupling for builds
import * as React from 'react';

import classNames from 'classnames';

import a11yKeyPress from 'js/lib/a11yKeyPress';

import _t from 'i18n!nls/teach-course';

import 'css!./__styles__/ToggleSwitch';

const STATUS = {
  On: 'on',
  Off: 'off',
} as const;

export type StatusEnum = 'on' | 'off';

type Props = {
  defaultStatus?: StatusEnum;
  value?: StatusEnum;
  onToggle: (newStatus: StatusEnum) => void;
  disableToggle?: boolean;
  hideStatusText?: boolean;
  ariaLabel?: string;
  ariaDescribedBy?: string;
  id?: string;
};

type State = {
  status?: StatusEnum;
};

class ToggleSwitch extends React.Component<Props, State> {
  static defaultProps = {
    disableToggle: false,
    hideStatusText: false,
  };

  constructor(props: Props) {
    super(props);

    this.state = {
      status: props.value || props.defaultStatus,
    };
  }

  static getDerivedStateFromProps(nextProps: Props) {
    if (nextProps.value !== undefined) {
      return { status: nextProps.value };
    }
    return null;
  }

  onClick = () => {
    const { status } = this.state;
    const { onToggle } = this.props;
    const newStatus = status === STATUS.Off ? STATUS.On : STATUS.Off;

    this.setState({
      status: newStatus,
    });

    onToggle(newStatus);
  };

  static getStatus = function () {
    return STATUS;
  };

  render() {
    const { disableToggle, hideStatusText, ariaLabel, ariaDescribedBy, id } = this.props;
    const { status } = this.state;
    const toggleClasses = classNames('rc-ToggleSwitch', status);
    const statusText = status === STATUS.Off ? _t('No') : _t('Yes');

    return (
      <div
        id={id}
        className={toggleClasses}
        role="switch"
        aria-checked={status === STATUS.On}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedBy}
        onClick={!disableToggle ? this.onClick : undefined}
        onKeyPress={(event) => !disableToggle && a11yKeyPress(event, this.onClick)}
        tabIndex={!disableToggle ? 0 : -1}
      >
        <span className="toggle-handle" />
        {!hideStatusText && statusText}
      </div>
    );
  }
}

export default ToggleSwitch;
